import { apiClient } from './client';

export interface HgConfig {
  enabled: boolean;
  hasToken: boolean;
  hasSecret: boolean;
  accountId: string | null;
  baseUrl: string;
}

export interface HgCheckoutResult {
  paymentId: string;
  checkoutId: string;
  checkoutUrl: string | null;
  accountDisplay: Record<string, unknown> | null;
  qrCode: string | null;
  pixCopiaECola: string | null;
  expiresAt: string | null;
  status: string;
}

export interface HgPayoutResult {
  ok: boolean;
  paymentId: string;
  hgTransactionId: string;
  status?: string;
}

export const hgcashApi = {
  config: async (): Promise<HgConfig> => {
    const { data } = await apiClient.get<HgConfig>('/hgcash/config');
    return data;
  },
  checkout: async (params: {
    clientId: string;
    amount: number;
    conversationId?: string;
    country?: 'AR' | 'BR' | 'CL';
  }): Promise<HgCheckoutResult> => {
    const { data } = await apiClient.post<HgCheckoutResult>('/hgcash/checkout', params);
    return data;
  },
  payout: async (params: {
    paymentId: string;
    toCBU?: string;
    toCVU?: string;
    toName?: string;
    toCUIT?: number;
    concept?: string;
  }): Promise<HgPayoutResult> => {
    const { data } = await apiClient.post<HgPayoutResult>('/hgcash/payout', params);
    return data;
  },
};
